import React from 'react'

import { type IconProps, defaultPropsV2 } from './IconProps'

export const ArrowLeft = (props: IconProps) => {
  return (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M-9.27607e-05 7.99999C-9.27809e-05 8.23149 0.10205 8.441 0.287638 8.61722L7.36542 15.7067C7.5805 15.9166 7.78904 16 8.01116 16C8.46998 16 8.8224 15.657 8.8224 15.1972C8.8224 14.9751 8.75257 14.7571 8.59511 14.609L5.80632 11.7776L1.87965 8.16452L1.68566 8.6486L4.97104 8.83514L18.9418 8.83514C19.4245 8.83514 19.7676 8.48272 19.7676 7.99999C19.7676 7.51727 19.4245 7.16485 18.9418 7.16485L4.97104 7.16485L1.68566 7.35138L1.87965 7.82609L5.80632 4.22239L8.59511 1.39094C8.74837 1.24707 8.82241 1.02495 8.82241 0.8028C8.82241 0.343047 8.46999 -3.39927e-08 8.01116 -7.41042e-08C7.78904 -9.35225e-08 7.58893 0.0834168 7.40335 0.255418L0.287638 7.38277C0.10205 7.55898 -9.27405e-05 7.76849 -9.27607e-05 7.99999Z"
        fill={props.colour}
      />
    </svg>
  )
}
ArrowLeft.defaultProps = defaultPropsV2
